export var NotificationType;
(function (NotificationType) {
    //batchable
    //on demand
    NotificationType["MISC"] = "misc";
    NotificationType["APP_UPDATES"] = "app_updates";
    NotificationType["NEWLY_VERIFIED_TOKENS"] = "newly_verified_tokens";
    //unbatchable
    //on demand
    //done
    NotificationType["USER_TRANSFER"] = "transfer";
    //done
    NotificationType["FRIEND_REQUESTS"] = "friend_requests";
    //done
    NotificationType["FRIEND_TRADES"] = "friend_trades";
    //not in scope for right now
    NotificationType["WHALE_TRADES"] = "whale_trades";
    //time chron
    //done
    NotificationType["PORTFOLIO_UPDATES"] = "portfolio_updates";
    //not in scope for right now
    NotificationType["SAVED_TOKENS"] = "saved_tokens";
    NotificationType["RECENTS_TOKENS"] = "recents_tokens";
})(NotificationType || (NotificationType = {}));
export const NotificationMessages = {
    [NotificationType.PORTFOLIO_UPDATES]: {
        title: (tokenSymbol) => `Portfolio Update: ${tokenSymbol}`,
        message: (tokenSymbol, percentageChange) => `You're ${percentageChange > 0 ? 'up' : 'down'} ${percentageChange}% on ${tokenSymbol}`,
    },
};
